import { useMemo } from 'react';

import { CompensationType } from 'enums';

import { CONSENT_REQUIRED_TYPES } from '../consent-policy.config';

interface Params {
  benefitType?: CompensationType;
  compensationType?: CompensationType;
  isNew?: boolean;
  isUserMode?: boolean;
}

export const getIsTypeSelectDisabled = ({ benefitType, compensationType, isNew, isUserMode }: Params) => {
  const selectedBenefitType = benefitType ?? compensationType;
  const isMedicalType = selectedBenefitType === CompensationType.Medical;

  return !isUserMode && (isMedicalType || (!isNew && selectedBenefitType === CompensationType.Robotics));
};

export const getShouldHideRestrictedTypes = ({ compensationType, isNew, isUserMode }: Params) =>
  !isUserMode &&
  (isNew || (compensationType !== CompensationType.Medical && compensationType !== CompensationType.Robotics));

export const useCompensationTypePolicy = ({ benefitType, compensationType, isNew, isUserMode }: Params) => {
  return useMemo(() => {
    const selectedBenefitType = benefitType ?? compensationType;
    const isMedicalType = selectedBenefitType === CompensationType.Medical;
    const shouldUseQuarterPeriods = isMedicalType || selectedBenefitType === CompensationType.Robotics;
    const shouldHideRestrictedTypes = getShouldHideRestrictedTypes({ compensationType, isNew, isUserMode });
    const isTypeSelectDisabled = getIsTypeSelectDisabled({ benefitType, compensationType, isNew, isUserMode });
    const requiresConsentType = selectedBenefitType ? CONSENT_REQUIRED_TYPES.includes(selectedBenefitType) : false;

    return {
      selectedBenefitType,
      isMedicalType,
      shouldUseQuarterPeriods,
      shouldHideRestrictedTypes,
      isTypeSelectDisabled,
      requiresConsentType,
    };
  }, [benefitType, compensationType, isNew, isUserMode]);
};
